import { login,transferLogin,getInfo, logout, unReadCount } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'
import qs from 'qs';

const state = {
  token: getToken(),
  user: {},
  name: '',
  avatar: '',
  permissions: [],
  unReadCount: 0,
  roles: [],
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, SET_AVATAR) => {
    state.SET_AVATAR = SET_AVATAR
  },
  SET_USER: (state, user) => {
    state.user = user
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  },
  SET_UNREADCOUNT: (state, unReadCount) => {
    state.unReadCount = unReadCount
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login(qs.stringify({ _username: username.trim(), _password: password})).then(response => {
        // const { data } = response
        
        // commit('SET_TOKEN', response.data.token);
        // commit('SET_NAME', response.data.user.nickname)
        commit('SET_USER', response.data.user);
        commit('SET_PERMISSIONS', response.data.permissions);
        setToken(response.data.sessionid)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  transferLogin({ commit }, userInfo) {
    const { token, id } = userInfo
    return new Promise((resolve, reject) => {
      transferLogin({ token: token, id: id}).then(response => {
        // const { data } = response
        
        // commit('SET_TOKEN', response.data.token);
        // commit('SET_NAME', response.data.user.nickname)
        commit('SET_USER', response.data.user);
        commit('SET_PERMISSIONS', response.data.permissions);
        setToken(response.data.sessionid)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {

    return new Promise((resolve, reject) => {
      getInfo().then(response => {
        const { data } = response

        // if (!data) {
        //   reject('Verification failed, please Login again.')
        // }

        const { nickname, avatar, roles } = response.data.user
        commit('SET_USER', response.data.user);
        commit('SET_PERMISSIONS', response.data.permissions);
        commit('SET_NAME', nickname)
        commit('SET_AVATAR', avatar)
        commit('SET_ROLES', roles)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then((res) => {
        commit('SET_USER', '')
        commit('SET_TOKEN', '')
        removeToken()
        // resetRouter()
        window.location = res.data;
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken()
      resolve()
    })
  },
  updateUnReadCount({ commit , state}) {
    return new Promise((resolve, reject) => {
      unReadCount().then(response => {
        const { data } = response
        commit('SET_UNREADCOUNT', data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

